import type {
    ApplyCommerceCheckoutCustomerRequest,
    ApplyCommerceCheckoutCustomerResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const applyCommerceCheckoutCustomerOperation = defineCommerceOperation<
    ApplyCommerceCheckoutCustomerRequest,
    ApplyCommerceCheckoutCustomerResponse
>("commerce.checkout.customer.apply");
